import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class BatchTransferProvider extends HttpRequest {
  paginate (query) {
    this.setHeader(getAuthToken())
    // backend rejects uploadStatus='' (only accepts a real enum value or the key omitted)
    const params = { ...query }
    if (!params.uploadStatus) delete params.uploadStatus
    return this.get('/batch-transfers', params)
  }

  getCount () {
    this.setHeader(getAuthToken())
    return this.get('/batch-transfers/count')
  }

  create (formData) {
    this.setHeader(getAuthToken())
    return this.post('/batch-transfers', formData)
  }

  getById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/batch-transfers/${id}`)
  }

  getRows (id, query) {
    this.setHeader(getAuthToken())
    return this.get(`/batch-transfers/${id}/rows`, query)
  }

  cancel (id) {
    this.setHeader(getAuthToken())
    return this.post(`/batch-transfers/${id}/cancel`)
  }

  // responseType: 'blob' skips the {message, data} envelope — the response IS the file
  downloadFile (id) {
    this.setHeader(getAuthToken())
    return this.get(`/batch-transfers/${id}/file`, null, { responseType: 'blob' })
  }

  exportGroup (id, group) {
    this.setHeader(getAuthToken())
    return this.get(`/batch-transfers/${id}/export`, { group }, { responseType: 'blob' })
  }
}

export default BatchTransferProvider
